import React, { Component } from 'react'

class Wallet extends Component {
  state = {
    selectedCard: false,
  }

  componentDidMount() {
    this.renderWallet()
  }

  renderWallet = () => {
    new window.OffAmazonPayments.Widgets.Wallet({
      sellerId: this.props.sellerId,
      agreementType: this.props.agreementType,
      design: { designMode: 'responsive' },
      onReady: (billingAgreement) => {
        this.setState({ billingAgreement: billingAgreement })
      },
      onPaymentSelect: () => {
        this.setState({ selectedCard: true })
      },
      onError: (error) => {
        console.log(error)
      }
    }).bind('walletWidgetDiv')
  }  

  proceedToConsent = () => {
    if (this.state.selectedCard) {
      this.props.displayConsent(this.state.billingAgreement)
    }
  }

  render() {
    return (
      <div className="wallet">
        <div className="wallet-wrapper">
          <div id="walletWidgetDiv">
            {this.renderWallet}
          </div>
        </div>
        { this.state.selectedCard && 
        <div className="btn-wrapper">
          <button 
            onClick={this.proceedToConsent} 
            disabled={!this.state.selectedCard}
            className="cont-ap-btn"
          >
            Continue
          </button> 
        </div> }
      </div>
    )
  }
}

export default Wallet